/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

/**
 * Checks if the given element template is a connector template.
 * @param {Object|string} elementTemplate - The element template to check, can be an object or a JSON string.
 * @returns {boolean} True if the element template is a connector template, false otherwise.
 */
export const isConnectorTemplate = (elementTemplate) => {
  const elementTemplateParsed = parseElementTemplate(elementTemplate);
  return elementTemplateParsed?.category?.id === 'connectors';
};

/**
 * Checks if the given element template is an IDP connector template.
 * @param elementTemplate - The element template to check, can be an object or a JSON string.
 * @returns {boolean} True if the element template is an IDP connector template, false otherwise.
 */
export const isIdpConnectorTemplate = (elementTemplate) => {
  const elementTemplateParsed = parseElementTemplate(elementTemplate);
  return elementTemplateParsed?.category?.id === 'idpExtractionProject';
};

const parseElementTemplate = (elementTemplate) => {
  if (typeof elementTemplate === 'string') {
    try {
      return JSON.parse(elementTemplate);
    } catch (error) {
      console.error('Invalid JSON string provided for element template:', error);
      return null;
    }
  }
  return elementTemplate;
};
